import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import TemplateForm from '../../components/Templates/TemplateForm';
import templateService from '../../services/templateService';

const TemplateCreate = () => {
  const navigate = useNavigate();

  const handleSubmit = async (templateData) => {
    try {
      await templateService.createTemplate(templateData);
      toast.success('Template created successfully');
      navigate('/app/templates');
    } catch (error) {
      console.error('Error creating template:', error);
      toast.error(error.response?.data?.error || 'Failed to create template');
    }
  };

  const handleCancel = () => {
    navigate('/app/templates');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Create New Template</h1>
        <p className="text-gray-600 mt-1">Create a reusable template for your organization</p>
      </div>

      <TemplateForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </div>
  );
};

export default TemplateCreate;

